<template>
    <div>
        <div style="margin: 3px 0px 3px 0px;padding: 3px;background: white">
            <el-row style="display: flex">
                <el-tooltip class="item" effect="dark" content="刷新" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-refresh-right" circle @click="reflash" type="success"></el-button>
                </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="导出积分" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-download" circle @click="expt" type="warning"></el-button>
                </el-tooltip>
            </el-row>
            <el-row>
                <el-select v-model="status" clearable size="medium" style="margin-left: 8px">
                    <el-option key="0" label="草稿" value="0"></el-option>
                    <el-option key="1" label="新建" value="1"></el-option>
                    <el-option key="2" label="提交" value="2"></el-option>
                    <el-option key="3" label="发货" value="3"></el-option>
                    <el-option key="4" label="签收" value="4"></el-option>
                </el-select>
                <el-input v-model="queryKey" type="text"
                          @click.native.prevent="getView"
                          @keyup.enter.native="getView"
                          suffix-icon="el-icon-search"
                          size="medium" style="width:200px;margin-left: 8px"></el-input>
                <el-tooltip class="item" effect="dark" content="查询" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-search" circle @click="getView"></el-button>
                </el-tooltip>
            </el-row>
        </div>
        <el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
        >
            <el-table-column type="selection" v-if="false"></el-table-column>
            <!--<el-table-column show-overflow-tooltip prop="dealeriid" label="经销商ID"></el-table-column>-->
            <el-table-column show-overflow-tooltip prop="dealername" label="经销商名称"></el-table-column>
            <el-table-column show-overflow-tooltip prop="rolelv" label="经销商级别"></el-table-column>
            <el-table-column show-overflow-tooltip prop="ordertime" label="订单时间"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productname" label="品名"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productmodel" label="型号"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productspecs" label="规格"></el-table-column>
            <el-table-column show-overflow-tooltip prop="retailprice" label="零售价" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="provincialprice" label="省代价格" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="cityprice" label="市代价格" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="ordernum" label="数量" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="status" label="订单状态">
                <template scope="scope">
                    <span>{{expstatus(scope.row.status)}}</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="points" label="积分分数"></el-table-column>
        </el-table>
        <el-row>
            <el-col :span="18">
                <el-pagination
                        style="margin-top: 1em"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="100"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    import axios from 'axios';

    export default {
        data() {
            return {
                dataSet: [],
                dataDetail: {},
                userData: [], // 用户信息
                user: "",
                usercode: "",
                useriid: "",
                userrolelv: "",
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                tableHeight: window.innerHeight - 250, // 主表高度
                queryKey: "",
                SortList: [],
                ScreenList: [],
                status:""
            };
        },
        mounted: function () {
            let that = this
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.token = that.userData.token
            that.user = that.userData.username
            that.usercode = that.userData.Login_Code
            that.useriid = that.userData.iid
            that.userrolelv = that.userData.rolelv
            that.getView()
        },
        methods: {
            handleSizeChange(val) {
                this.pageSize = val;
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val
                this.SelectIndexs = val;
                this.getView();
            },
            reflash() {
                let that = this
                that.queryKey = ""
                that.status = ""
                that.getView()
            },
            getView() {
                let that = this
                that.loading = true
                let parm = {
                    PageSize: that.pageSize,
                    PageIndex: that.pageIndex,
                    QueryKey: that.queryKey,
                    iid: "",
                    SortList: that.SortList,
                    ScreenList: that.ScreenList,
                    status: that.status,
                    dealercode: that.usercode
                };
                that.$http.urlpost('/TransPoints/View', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            expstatus(value) {
                if (value == 0) {
                    return '草稿'
                } else if (value == 1) {
                    return '新建'
                } else if (value == 2) {
                    return '提交'
                } else if (value == 3) {
                    return '发货'
                } else if (value == 4) {
                    return '签收'
                } else {
                    return ''
                }
            },
             expt() {
                let that = this
                let parm = {
                    PageSize: that.pageSize,
                    PageIndex: that.pageIndex,
                    QueryKey: that.queryKey,
                    iid: "",
                    SortList: that.SortList,
                    dealercode: that.usercode,
                    ScreenList: that.ScreenList
                };
                that.$http.urlpost('/TransPoints/Export', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.Key;
						window.open(hrefurl);
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
        }
    };
</script>

<style scoped lang="less">
</style>
